import {
	Flex,
	Heading,
	Image,
	Link,
	Text,
	useColorModeValue,
} from '@chakra-ui/react'
import React from 'react'
import me from '../assets/images/me.avif'
import PageHeader from '../components/PageHeader'
import './About.css'
const ChineseText = (props) => {
	return (
		<Text
			fontFamily="New Tegomin"
			color=" #aa381e"
			ml={['-20px', '-16px']}
			display={['block', 'inline']}
			{...props}
		>
			{props.children}
		</Text>
	)
}
const Speech = (props) => {
	return (
		<Text
			fontFamily="Covered By Your Grace"
			color="#fb9912"
			py={'2'}
			{...props}
		>
			{props.children}
		</Text>
	)
}
const Avatar = (props) => {
	return (
		<Image
			height="12rem"
			borderRadius={{ base: '20px', md: 'full' }}
			display="inline-block"
			mr={{ base: '0', md: '6' }}
			mb="6"
			objectFit="cover"
			style={{
				boxShadow:
					'0 4px 8px 0 rgba(0, 0,0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
			}}
			{...props}
		/>
	)
}
export default function About() {
	return (
		<div data-aos="fade-up">
			<PageHeader
				bgColor={useColorModeValue('#AED1B6', '#5C7A5E')}
				title="about"
				subtitle="interest, hobbies, project"
			/>
			<Flex maxWidth="720px" direction="column" data-aos="fade-up">
				<Flex direction={{ base: 'column', md: 'row' }}>
					<Avatar src={me} alt="me" />
					<Flex direction="column">
						<Heading fontSize="4xl" mb={'4'} display="inline-block">
							Fabian Chua <ChineseText>「蔡昇融」</ChineseText>
						</Heading>
						<Text fontSize="xl">
							He is a Software Engineer at IRAS, and a Software Engineering
							graduate from Singapore Institute of Technology. He has various
							interests in tech, with a focus on product and frontend development.
							<br />
							<Speech>Ok let me jump out of third person already.</Speech>
						</Text>
					</Flex>
				</Flex>
				<Text fontSize="xl">
					Hi, Fabian here! Personally, I am an avid learner who is passionate
					about making impactful designs to simplify our daily lives. Simply
					put, I enjoy solving complex problems with good design that just make
					things make sense.
					<Speech>Make it make sense man.</Speech>
				</Text>
				<Text fontSize="xl" mb="4">
					Currently, I'm a Software Engineer at{' '}
					<Link color="#6197D1">IRAS</Link> under the Management Associate
					Programme. Previously, I was a Product Manager at{' '}
					<Link color="#F0B90B">Binance</Link> and a Software Engineer at{' '}
					<Link color="#00D395">Switcheo Labs</Link>. I also had stints at{' '}
					<Link color="#19C1F3">GovTech</Link> as a Product Manager and at{' '}
					<Link color="#A100FF">Accenture</Link> as a Frontend Engineer.
				</Text>
				<Text fontSize="xl" mb="4">
					I actively participate in hackathons – notably winning "Most Beautiful
					Hack" at NUS Hack&Roll 2024, and "Bybit's Most Reliable Fintech
					Solution" at NUS Fintech Hackathon 2023.
				</Text>
				<Text fontSize="xl" mb="4">
					Outside of tech, I enjoy the company of people, good food and football
					on the weekends – both playing and watching (Manchester United).
				</Text>
			</Flex>
		</div>
	)
}
